import { useEffect, useState, useRef } from "react";
import styles from "./ConfirmDetails.module.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { MdOutlineKeyboardArrowRight } from "react-icons/md";

// components
// import MainHeader from "../../components/Header/MainHeader";

import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { storeLeadID } from "../../utils/storage";
import CustomButton from "../../components/Button/CustomButton";
import { googleEvent_LOJ190, googleEvent_LOJ193 } from "../../lib/google-analytics-loan-journey-events";
import { addRepeatCustomer } from "../../redux/slices/userSlice";
// import { addCompanyName, addEmploymentDetails, addLoanPurpose, addMonthlyIncome, addPaymentMode } from "../../redux/slices/registerSlice";
import { Formik } from "formik";
import * as Yup from "yup";
import { getEnvironment } from "../../utils/environment";
import api from "../../utils/api";
import { googleEvent_LOJ226 } from "../../lib/google-analytics";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { MONTHLY_INCOME_CONSENT_TEXT } from "../../Constants/constant";
import UserConsent from "../../components/userConsent";
import { clevertap_sv_one_page,
  clevertap_one_page_back_clk,
  clevertap_one_page_edit_sel,
  clevertap_one_page_continue_clk
 } from "../../lib/clevertap-events";

const confirmDetailsValidation = Yup.object().shape({
  loanPurpose: Yup.string().required("Loan purpose is required"),
  employmentType: Yup.string().required("Employment type is required"),
  modeOfPayment: Yup.string().required("Mode of payment is required"),
  // companyName: Yup.string()
  //   .trim()
  //   .min(2, "Company name must be at least 2 characters")
  //   .max(100, "Company name is too long")
  //   .required("Company name is required"),

  monthlySalary: Yup.number()
    .typeError("Monthly salary must be a number")
    .positive("Monthly salary must be greater than 0")
    .min(5000, "Monthly salary must be at least 5000")
    .required("Monthly salary is required"),
  salaryDate: Yup.string().required("Salary date is required"),
});

export default function ConfirmDetails() {
  const [monthlyIncomeConsent] = useState(true);
  const nextButtonRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const newLoanAmount = localStorage.getItem("loanAmount");

  const { API_URL } = getEnvironment();

  const { employmentDetails, companyName, loanAmount, loanPurpose, paymentMode, monthlyIncome } = useSelector((state) => state.register);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { checkRepeatCaseAPI } = new AfterOnboardAPI();
  const prevIdxRef = useRef(window.history.state?.idx);

  // const { handleStep } = useResponse();

  const storeFieldInSorage = (data) => {
    localStorage.setItem("loan_purpose", data?.loanPurpose);
    localStorage.setItem("employment_type", data?.employmentType);
    localStorage.setItem("payment_mode", data?.modeOfPayment);
    localStorage.setItem("monthly_salary", data?.monthlySalary);
    localStorage.setItem("salary_date", data?.salaryDate);
  }

  useEffect(() => {
    googleEvent_LOJ190("", "");
    clevertap_sv_one_page();

    const fetchOnePageAPI = async () => {
      setLoading(true);
      const { onePageGetDetailsAPI } = new AfterOnboardAPI();
      const res = await onePageGetDetailsAPI();
      console.log(res);

      if (res) {
        const data = {
          ...res.data,
          loanPurpose: loanPurpose ? loanPurpose : res.data.loanPurpose,
          modeOfPayment: paymentMode ? paymentMode : res.data.modeOfPayment,
          monthlySalary: monthlyIncome ? monthlyIncome : res.data.monthlySalary,
        };
        setData(data);
        storeFieldInSorage(data);

        if (res.data.repeat) {
          dispatch(addRepeatCustomer(true));
        } else {
          dispatch(addRepeatCustomer(false));
        }
      }
      setLoading(false);
    };

    fetchOnePageAPI();
    return () => {
          const currentIdx = window.history.state?.idx;
          if (
            prevIdxRef.current !== undefined &&
            currentIdx < prevIdxRef.current
          ) {
            clevertap_one_page_back_clk()
          }
        };
  }, []);

  const loanAmountBucket = () => {
    const offerLoanAmount = Number(localStorage.getItem("offerLoanAmount")) || 0;
    if (offerLoanAmount <= 10000) return 0;
    if (offerLoanAmount <= 25000) return 1;
    if (offerLoanAmount <= 50000) return 2;
    if (offerLoanAmount <= 75000) return 3;
    if (offerLoanAmount <= 100000) return 4;
    if (offerLoanAmount <= 150000) return 5;
    if (offerLoanAmount <= 200000) return 6;
    return 7;
  }

  const handleConfirmDetails = async (values) => {
    googleEvent_LOJ193("", "");
    setLoading(true);
    handleShowContextualLoader("Almost done! Final touches on your loan...");
    const res = await checkRepeatCaseAPI({...values, monthlyIncomeConsent });

    clevertap_one_page_continue_clk({
      loan_pupose: values.loanPurpose || "NA",
      employment: values.employmentType || "NA",
      payment_mode: values.modeOfPayment || "NA",
      monthly_salary: values.monthlySalary || "NA",
      salary_date: values.salaryDate || "NA",
      loan_amount_bucket: loanAmountBucket() || "NA",
      emi_plan: localStorage.getItem("emi_plan") || "NA",
      offer_type: localStorage.getItem("offer_type") || "NA",
      error_code: res?.data?.error_code || "NA"
    });
    storeFieldInSorage(values);
    if (res && res.statusCode === 200) {
      if (res?.data?.leadID) {
        storeLeadID(res.data.leadID);
      }

      if (res.data.pageName === "rejected") {
        navigate("/loan-reject");
      } else if (res.data.pageName === "finbox") {
        googleEvent_LOJ226();
        navigate(`/finbox?url=${res?.data?.metaData.finbox.redirect_url}`);
      } else if (res.data.pageName === "approval") {
        navigate("/select-loan");
      } else if (res.data.pageName === "dashboard") {
        navigate("/dashboard");
      } else {
        navigate("/home");
      }

      localStorage.removeItem("loanAmount");
    }
    handlehideContextualLoader(500);
    setLoading(false);
  };

  const loanPurposeDropdown = ["Medical Emergency", "Salary Delay", "Personal Emergency", "Education", "Rent / Bills", "Others"];

  const employeeTypeDropdown = [
    { label: "Salaried", value: "Salaried" },
    { label: "Self Employed", value: "Self Employee" },
  ];

  const paymentModeDropdown = ["Bank Transfer", "Cheque", "Cash"];

  const salaryDateDropdown = Array.from({ length: 31 }, (_, i) => i + 1);

  const handleUpdateSalary = async (value) => {
    try {
      const endpoint = API_URL + "/customers/incompleteDetailsUpdate";
      const req = {
        salary_date: value,
        leadID: Number(localStorage.getItem("leadID")),
        repeat: true,
      };

      const { data } = await api.put(endpoint, req);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if(!data) return;
    const { loanPurpose, employementType, modeOfPayment, monthlySalary, salaryDate, isRepeat } = data;
    if(!isRepeat) {
      handlehideContextualLoader();
      return;
    };
    const onePageReq = {
      loanPurpose,
      employementType,
      modeOfPayment,
      monthlySalary,
      salaryDate
    };
    const isOnePageAllDetails = Object.values(onePageReq).some(value => !value || value === '');
    if(!isOnePageAllDetails) {
      nextButtonRef.current.submitForm();
    } else {
      handlehideContextualLoader();
    }
  }, [data])
  if (!data) {
    handleShowContextualLoader("Opening your loan form...")
    return null;
  }

  return (
    <>
      <div className={`wrapper auto-height ${styles.confirmDetails__styles}`}>
        {/* <MainHeader title="User Details" showProgress={false} /> */}
        <div className="mb-2">
          <p className="label">Confirm your details</p>
        </div>

        <Formik
          innerRef={nextButtonRef}
          initialValues={{
            loanPurpose: data?.loanPurpose || "",
            employmentType: data.employementType || "",
            modeOfPayment: data.modeOfPayment || "",
            monthlySalary: data.monthlySalary || "",
            salaryDate: data.salaryDate || "",
          }}
          validationSchema={confirmDetailsValidation}
          enableReinitialize={true}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            setTimeout(async () => {
              await handleConfirmDetails(values);
              setSubmitting(false);
            }, 500);
          }}
        >
          {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit} style={{ paddingBottom: "140px" }}>
              <div>
                <div className="form-group">
                  <label className="label-sm">Loan Purpose</label>
                  <select
                    className="form-select"
                    name="loanPurpose"
                    value={values.loanPurpose}
                    onChange={handleChange}
                    onBlur={(e) => {
                      setFieldValue("loanPurpose", e.target.value);
                       clevertap_one_page_edit_sel({}, 'one_page_loan_pupose_edit_sel');
                    }}
                  >
                    <option value="" key="default">
                      Select Loan Purpose
                    </option>
                    {loanPurposeDropdown.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>

                  {touched.loanPurpose && errors.loanPurpose ? <div className="error-msg">{errors.loanPurpose}</div> : null}
                </div>

                <div className="form-group">
                  <label className="label-sm">Employment Type</label>
                  <select
                    className="form-select"
                    name="employmentType"
                    value={values.employmentType}
                    onChange={handleChange}
                    onBlur={(e) => {
                      setFieldValue("employmentType", e.target.value);
                       clevertap_one_page_edit_sel({}, 'one_page_employment_type_edit_sel');
                    }}
                  >
                    <option value="" key="default">
                      Select Employment Type
                    </option>
                    {employeeTypeDropdown.map((item, index) => (
                      <option value={item.value} key={index}>
                        {item.label}
                      </option>
                    ))}
                  </select>

                  {touched.employmentType && errors.employmentType ? <div className="error-msg">{errors.employmentType}</div> : null}
                </div>

                <div className="form-group">
                  <label className="label-sm">Mode of Payment</label>
                  <select
                    className="form-select"
                    name="modeOfPayment"
                    value={values.modeOfPayment}
                    onChange={handleChange}
                    onBlur={(e) => {
                      setFieldValue("modeOfPayment", e.target.value);
                      clevertap_one_page_edit_sel({}, 'one_page_payment_mode_edit_sel');
                    }}
                  >
                    <option value="" key="default">
                      Select Mode of Payment
                    </option>
                    {paymentModeDropdown.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>

                  {touched.modeOfPayment && errors.modeOfPayment ? <div className="error-msg">{errors.modeOfPayment}</div> : null}
                </div>

                {/* <div className="form-group">
                  <label className="label-sm">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Company Name"
                    name="companyName"
                    value={values.companyName || ""}
                    onChange={handleChange}
                    onBlur={(e) => {
                      setFieldValue("companyName", e.target.value.trim());
                    }}
                    autoComplete="off"
                  />

                  {touched.companyName && errors.companyName ? <div className="error-msg">{errors.companyName}</div> : null}
                </div> */}

                <div className="form-group">
                  <label className="label-sm">Monthly Salary</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Monthly Salary"
                    name="monthlySalary"
                    value={values.monthlySalary || ""}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const inputValue = Number(e.target.value?.trim());
                      setFieldValue("monthlySalary", inputValue);
                      clevertap_one_page_edit_sel({}, 'one_page_monthly_salary_edit_sel');
                    }}
                    autoComplete="off"
                  />

                  {touched.monthlySalary && errors.monthlySalary ? <div className="error-msg">{errors.monthlySalary}</div> : null}
                </div>

                <div className="form-group">
                  <label className="label-sm">Salary Date</label>
                  <select
                    className="form-select"
                    name="salaryDate"
                    value={values.salaryDate}
                    onChange={async (e) => {
                      const value = e.target.value;
                      setFieldValue("salaryDate", value);
                      await handleUpdateSalary(value);
                    }}
                    onBlur={(e) => {
                      setFieldValue("salaryDate", e.target.value);
                      clevertap_one_page_edit_sel({}, 'one_page_salary_date_edit_sel');
                    }}
                  >
                    <option value="">Select Salary Date</option>
                    {salaryDateDropdown.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>

                  {touched.salaryDate && errors.salaryDate ? <div className="error-msg">{errors.salaryDate}</div> : null}
                </div>
              </div>

              <div className={styles.floatingSubBtn}>
              <UserConsent
                  name="monthlyIncomeConsent"
                  checked={monthlyIncomeConsent}
                  text={MONTHLY_INCOME_CONSENT_TEXT}
                />
                <CustomButton floating={false}  text="Next" type="submit" />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
}
